import { render, staticRenderFns } from "./RemoteOpen.vue?vue&type=template&id=95ddf92a"
import script from "./RemoteOpen.vue?vue&type=script&lang=js"
export * from "./RemoteOpen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports